export const LOGIN= 'login'
export const NEAREST_LOCATION= 'nearest-location';
export const CITY_STATE= 'city-state';
export const STATE= 'state';
export const CLUSTER= 'cluster';
export const AUDIO ='audio'
export const ADMIN_LOGIN ='admin-login'
export const LOAD_AUTH_INFO ='admin-auth'

// export const CLEAR_ERROR= 'clear-error';
export const ANY_ERROR= 'any-error';

export const KYC_DETAILS= 'kyc-details';

export const CAMPAIGN_DETAILS = 'campaign-details';

export const INCREASE_REQUEST = 'admin@request-increase';
export const DECREASE_REQUEST = 'admin@request-decrease';

/**Admin Types */
export const ADMINS_DATA ='admins-admin';


// WEBPACK FOOTER //
// ./web/action/user_action_types.jsx